module.exports = __webpack_public_path__ + "img/phone.f86873c4.png";